import * as React from 'react';
import { useGroundingCommandBarActions_unstable } from './useGroundingCommandBarActions';
import { renderGroundingCommandBarActions_unstable } from './renderGroundingCommandBarActions';
import { useGroundingCommandBarActionsStyles_unstable } from './useGroundingCommandBarActionsStyles.styles';
import type { GroundingCommandBarActionsProps } from './GroundingCommandBarActions.types';
import type { ForwardRefComponent } from '@fluentui/react-components';

// GroundingCommandBarActions component - TODO: add more docs
export const GroundingCommandBarActions: ForwardRefComponent<GroundingCommandBarActionsProps> = React.forwardRef(
  (props, ref) => {
    const state = useGroundingCommandBarActions_unstable(props, ref);

    useGroundingCommandBarActionsStyles_unstable(state);
    return renderGroundingCommandBarActions_unstable(state);
  },
);

GroundingCommandBarActions.displayName = 'GroundingCommandBarActions';
